import React from 'react';
import { connect } from '@cerebral/react';
import { signal, state } from 'cerebral/tags';
import { Document, Page } from 'react-pdf/dist/entry.noworker';
import { baseURL } from '../constants';
import theme from './Poster.scss';
import { Loader } from './';

const Poster = ({ id, trackEvent }) => (
    <div className={`d-flex justify-content-center align-items-center flex-column ${theme.posterContainer}`}>
        <div className={theme.poster}>
            {
                id && (
                    <Document
                        loading={<Loader />}
                        noData={<p className="text-center">Er ging iets mis bij het laden van de PDF, probeer het later nog eens opnieuw.</p>}
                        file={`${baseURL}/state/${id}/pdf-inline`}
                    >
                        <Page
                            width={400}
                            pageNumber={1}
                        />
                    </Document>
                )
            }
        </div>
        <a
            className={`btn btn-secondary ${theme.downloadButton}`}
            href={`${baseURL}/state/${id}/pdf-inline`}
            target="_blank"
            onClick={() => {
                trackEvent({
                    eventAction: 'pdf_downloaded',
                });
            }}
        >
            Bekijk de poster
        </a>
    </div>
);

const stateSignal = {
    trackEvent: signal`app.trackEvent`,
    answers: state`app.answers`,
    id: state`app.id`,
};

export default connect(stateSignal, Poster);




// WEBPACK FOOTER //
// ./src/components/Poster.js